import { render } from "./hrm-payroll-hold-modal.vue?vue&type=template&id=5cf07054&scoped=true"
import script from "./hrm-payroll-hold-modal.vue?vue&type=script&lang=js"
export * from "./hrm-payroll-hold-modal.vue?vue&type=script&lang=js"

import "./hrm-payroll-hold-modal.vue?vue&type=style&index=0&id=5cf07054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf07054"]])

export default __exports__